import { render } from "./SystemAuditsView.vue?vue&type=template&id=3c483d60"
import script from "./SystemAuditsView.vue?vue&type=script&lang=js"
export * from "./SystemAuditsView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrateur\\Documents\\davca-cm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__